module.exports = __webpack_public_path__ + "media/open-treasure.acb2c804.mp3";